import React, { Component, cloneElement } from 'react';
import Chart from "react-google-charts";
import { Async } from 'react-select';
import classNames from 'classnames';
import Grid from "../../../Utils/Grid";
import { TableHeaderColumn } from "react-bootstrap-table";
import Card from "Utils/Cards/Card"
import DatePicker from 'react-datepicker';
import HeaderFiltros from '../../../Utils/Grid/HeaderFiltros';
import { USER_PROFESOR } from '../../../../../utility/constants';
import Rating from '@material-ui/lab/Rating';
import moment from 'moment';

import { api } from "api";
import LoadMask from '../../../Utils/LoadMask/LoadMask';

const getProfesores = (search) => {
    return api.get("user", { search, tipo_usuario: USER_PROFESOR }).then((data) => {
        if (data) return data.results;
        return [];
    }).catch(() => {
        return [];
    });
};

export default class PuntuacionesClases extends Component {

    componentWillMount() {
        this.props.listarGrafica();
        this.props.listarTabla();
    }


    changeFechaInicio = (value) => {
        const { fecha_fin } = this.props;
        if (value <= fecha_fin) {
            const comprobacion = moment(fecha_fin).subtract(6, 'M')
            if (value >= comprobacion) {
                this.props.changeFechaInicio(value);
            }
        }
    }

    changeFechaFin = (value) => {
        const { fecha_inicio } = this.props;
        if (value >= fecha_inicio) {
            const comprobacion = moment(fecha_inicio).add(6, 'M')
            if (value <= comprobacion) {
                this.props.changeFechaFin(value);
            }
        }
    }

    render() {
        const { listarTabla, listarGrafica } = this.props; //Funciones
        const { loader, data, data2, page } = this.props; //Constantes

        return (
            <div className="mb-4 col-12 mt-4">
                <HeaderFiltros
                    filtro1={
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            value={this.props.profesor}
                            isSearchable={true}
                            loadOptions={getProfesores}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["titulo"])}
                            type="text"
                            onChange={(e) => this.props.changeProfesor(e)}
                            multi={false}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container w-100')}
                            defaultOptions={true}
                            placeholder="Filtrar por profesor.."
                        />
                    }
                    filtro2={
                        <DatePicker
                            showPopperArrow={false}
                            isClearable
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha inicio"
                            onChange={this.changeFechaInicio}
                            selected={this.props.fecha_inicio}
                        />
                    }
                    filtro3={
                        <DatePicker
                            showPopperArrow={false}
                            isClearable
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha fin"
                            onChange={this.changeFechaFin}
                            selected={this.props.fecha_fin}
                        />
                    }
                />
                <Card>
                    <div className="d-flex flex-row flex-1 mt-3 mb-2">
                        <LoadMask loading={loader} blur>
                            <Chart
                                width='100%'
                                height={'50vh'}
                                chartType="LineChart"
                                loader={<div>Cargando grafica</div>}
                                data={data}
                                options={{
                                    hAxis: {
                                        title: 'Fechas',
                                        baselineColor: "#1C375E",
                                        titleTextStyle: {
                                            color: '#1C375E',
                                            bold: true,
                                            italic: false
                                        },
                                        textStyle: {
                                            color: "#1C375E",
                                            bold: false,
                                            italic: false
                                        },
                                    },
                                    vAxis: {
                                        title: 'Puntuaciones',
                                        // position: 'top',
                                        baselineColor: "#1C375E",
                                        titleTextStyle: {
                                            color: '#1C375E',
                                            bold: true,
                                            italic: false
                                        },
                                        textStyle: {
                                            color: "#1C375E",
                                            bold: false,
                                            italic: false
                                        },
                                    },
                                    pointSize: 7,
                                    curveType: 'function',
                                    chartArea: { width: '90%', height: '80%' },
                                    colors: ['#0336B5'],
                                    legend: { position: 'none' },
                                }}
                                rootProps={{ 'data-testid': '1' }}
                            />
                        </LoadMask>
                    </div>
                    <div className="my-5 px-lg-3">
                        <Grid
                            hover
                            striped
                            data={data2}
                            loading={loader}
                            onPageChange={listarTabla}
                            page={page}
                        >
                            <TableHeaderColumn
                                dataField="id"
                                dataAlign="center"
                                isKey
                                width='5%'
                                dataFormat={cell => ''}
                            />
                            <TableHeaderColumn
                                dataField="clase"
                                dataFormat={cell => moment(cell.fecha_hora_inicio).format("DD/MM/YYYY")}
                                width="10%"
                            >
                                Fecha
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="clase"
                                dataFormat={cell => cell.titulo}
                            >
                                Curso
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="profesor"
                            >
                                Profesor
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="calificacion"
                                dataFormat={cell => (
                                    <Rating
                                        name='calificacion'
                                        value={cell}
                                        size='medium'
                                        // disabled={true}
                                        readOnly={true}
                                    />
                                )}
                            >
                                Puntaje
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="comentario"
                                width="30%"
                            >
                                Comentario
                            </TableHeaderColumn>
                        </Grid>
                    </div>
                </Card>
            </div>
        )
    }


}

